<template>
  <v-card width="600" class="pa-5">
    <v-card-title class="primary--text text--darken-2 text-center">
      {{ platformName }}
    </v-card-title>
    <v-card-title class="justify-center">
      系統登入
    </v-card-title>
    <v-card-subtitle>請輸入帳號密碼登入</v-card-subtitle>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col>
            <v-text-field
              outline
              label="登入帳號"
              type="text"
              v-model="loginInfo.username"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              outline
              hide-details
              label="密碼"
              type="password"
              v-model="loginInfo.password"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="primary"
                rounded
                block @click="handleLogin">
                
                登入
              </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>

</template>
<script>
import Cookies from 'js-cookie'
import LoginService from '../services/LoginService'
import {mapMutations} from 'vuex';
export default{
    data () {
        return {
            darkTheme: true,
            platformName: process.env.VUE_APP_TITLE + " Login",
            loginInfo: null,
            message: '',
        }
    },
    created(){
      this.loginInfo = this.getLoginInfo()

    },
    methods:{
      ...mapMutations('auth',[
        'setAccessToken'
      ]),
      
      getLoginInfo(){
        var loginInfo
        if (Cookies.get('ckhlogin')){
          loginInfo = JSON.parse(Cookies.get('ckhlogin'))
          
        } else {
          loginInfo = {
            username: '', 
            password: '',
            keepLoginInfo: false,
            token: ''
          }
        }
        return loginInfo
      },
      handleLogin(){
        let username = this.loginInfo.username
        let password = this.loginInfo.password

        if (username !=='' &&  password !==''){
            LoginService.doLogin({
              email: username, 
              password: password
            }).then((response) =>{
              this.loginInfo.token = response.token
              //Set token to store
              this.setAccessToken(response.token);
              
              this.$router.replace('/');
            }).catch((e)=>{
              this.message = '登入失敗,' + e
              console.log(e)
            })
            
        } else {
          this.message ='帳號密碼不能為空'
        }
      }
    }
}
</script>
